/*
 Licensed Materials - Property of IBM
 5737-I23
 Copyright IBM Corp. 2019. All Rights Reserved.
 U.S. Government Users Restricted Rights:
 Use, duplication or disclosure restricted by GSA ADP Schedule
 Contract with IBM Corp.
 */
import React from 'react';
import { CustomArrayItem } from '../CustomArrayItem';

import { Button } from 'carbon-components-react';
import Add from '@carbon/icons-react/lib/add/16';

import './CustomArrayFieldTemplate.scss';

function CustomArrayFieldTemplate({ disabled, readonly, idSchema, formContext, items, canAdd, onAddClick, schema }) {

    // title and description are rendered by the CustomFieldTemplate
    return (
        <>
            <div
                className="row baiw--form-array-field__item_list"
                key={`array-item-list-${idSchema.$id}`}>
                {items && items.map((item, index) => {
                    item.key = `array-item-${idSchema.$id}-${index}`;
                    item.formContext = formContext;
                    return CustomArrayItem(item);
                })}
            </div>
            {canAdd && (
                <div>
                    <Button
                        className="array-item-add"
                        kind="ghost"
                        renderIcon={Add}
                        iconDescription={formContext ? formContext.addItemLabel : ''}
                        onClick={onAddClick}
                        disabled={disabled || readonly} >
                        {formContext ? formContext.addItemLabel : ''}
                    </Button>
                </div>
            )}
            {schema.invalid &&
                <div className="bx--form-requirement">{schema.invalidText}</div>
            }
        </>
    );
}

export { CustomArrayFieldTemplate };